<template>
  <div class="linkFormSectionWrap">
    <filter-resource-card
      :country="ruleForm.countryList"
      :app-version="ruleForm.wallpaperAppVersionList"
      :data-options="dataOptions"
      :android-begin-version.sync="ruleForm.androidBeginVersion"
      :android-over-version.sync="ruleForm.androidOverVersion"
      :android-neglect-version.sync="ruleForm.androidNeglectVersion"
      :ios-begin-version.sync="ruleForm.iosBeginVersion"
      :ios-over-version.sync="ruleForm.iosOverVersion"
      :ios-neglect-version.sync="ruleForm.iosNeglectVersion"
    />
  </div>
</template>

<script>
import filterResourceCard from '../../filterResourceCard.vue'

export default {
  name: 'GenericResourceFilterSection',
  components: { filterResourceCard },
  props: {
    ruleForm: { type: Object, required: true },
    dataOptions: { type: Array, default: () => [] },
  },
  methods: {
    validate() {
      return Promise.resolve()
    },
    captureSnapshot() {
      const form = this.ruleForm
      return {
        countryList: form.countryList,
        wallpaperAppVersionList: form.wallpaperAppVersionList,
        androidBeginVersion: form.androidBeginVersion,
        androidOverVersion: form.androidOverVersion,
        androidNeglectVersion: form.androidNeglectVersion,
        iosBeginVersion: form.iosBeginVersion,
        iosOverVersion: form.iosOverVersion,
        iosNeglectVersion: form.iosNeglectVersion,
      }
    },
  },
}
</script>
